import {Component, OnInit, ViewChild} from '@angular/core';
import {max} from 'rxjs/operators';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {ReportService} from '../../shared/service/report.service';
import {FormControl, FormGroup} from '@angular/forms';
import {StudioSearchModel} from '../../shared/dto/studio-search.model';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import Swal from 'sweetalert2';


/*
    Developed by Sajith Henarath
    sajith_h@epiclanka.net
 */

@Component({
  selector: 'app-studio-status-report',
  templateUrl: './studio-status-report.component.html',
  styleUrls: ['./studio-status-report.component.scss']
})
export class StudioStatusReportComponent implements OnInit {

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  requestForm: FormGroup;
  dateTimeRange: Date;
  dataSource: MatTableDataSource<any>;
  searchResult: StudioSearchModel[] = [];

  displayedColumns =['refNumber', 'name', 'birthDate', 'phone', 'dateAndTime'];

  constructor(private spinnerService: NgxUiLoaderService,
              private reportService: ReportService) { }

  ngOnInit() {
    this.requestForm = new FormGroup({
      dateTimeRange: new FormControl(null),
      refNumber: new FormControl(''),
      type: new FormControl('non'),
    });

  }

  onSubmitSearch(form: FormGroup) {
    let studioSearch = new StudioSearchModel();

    studioSearch.referenceNumber  = form.value.refNumber;
    studioSearch.dateRange = form.value.dateTimeRange;
    studioSearch.appType = form.value.type;
    console.log('ref: ' + studioSearch.referenceNumber);
    console.log('date: ' + studioSearch.dateRange);

    if (studioSearch.dateRange != undefined)
        this.loadSearchResult(studioSearch);
    else if (studioSearch.referenceNumber != '')
      this.loadSearchResult(studioSearch);
    else if (studioSearch.appType != 'non' && studioSearch.appType != null)
      this.loadSearchResult(studioSearch);
    else
      Swal.fire(
        'Please fill the required fields',
        '',
        'warning'
      );

  }

  loadSearchResult(searchCriteria: StudioSearchModel) {
    this.spinnerService.start();

    this.reportService.searchStudioStatusData(searchCriteria).subscribe(
      (result: StudioSearchModel[]) => {
        this.searchResult = [];

        if (result.length > 0) {
          this.searchResult = result;

        } else {
          Swal.fire('No data found', '', 'warning');
          this.resetData();

        }

        this.loadTableData();

      }, (error) => {
        Swal.fire(
          'An Unexpected Error Occurred',
          'Please try again later',
          'error'
        );
        console.error('Log: ' + error);
        this.resetData();

      }, () => {
        this.spinnerService.stop();

      }
    );


  }

  loadTableData() {
    this.dataSource = new MatTableDataSource(this.searchResult);

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.dataSource._updateChangeSubscription();

  }

  exportAsPDF() {
    this.spinnerService.start();

    if (this.searchResult.length > 0) {

      /*
      Date range structure in searchResult list as below
         0 element - created date of the relevant record
         1 element - from date
         2 element - to date

         1 and 2 element only will be added if date filtered search on.

       */

      this.reportService.studioReportExportPDF(this.searchResult).subscribe(
        (data: any) => {
          const file = new Blob([data], {type: 'application/pdf'});
          const fileURL = URL.createObjectURL(file);

          window.open(fileURL, "_blank");

        }, (error) => {
          Swal.fire(
            'An Unexpected Error Occurred',
            'Please try again later',
            'error'
          );
          console.error('Log: ' + error);

        }, () => {
          this.spinnerService.stop();

        }
      );
    } else {
      Swal.fire('No data found', '', 'warning');
    }

  }

  exportAsExcel() {
    this.spinnerService.start();

    if (this.searchResult.length > 0) {

      /*
      Date range structure in searchResult list as below
         0 element - created date of the relevant record
         1 element - from date
         2 element - to date

         1 and 2 element only will be added if date filtered search on.

       */

      this.reportService.studioReportExportExcel(this.searchResult).subscribe(
        (data: any) => {
          const file = new Blob([data], {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
          const fileURL = URL.createObjectURL(file);

          window.open(fileURL,"_blank");

        }, (error) => {
          Swal.fire(
            'An Unexpected Error Occurred',
            'Please try again later',
            'error'
          );
          console.error('Log: ' + error);

        }, () => {
          this.spinnerService.stop();

        }
      );
    } else {
      Swal.fire('No data found', '', 'warning');

    }
  }

  resetData() {
    this.requestForm.reset({
      dateTimeRange: null,
      refNumber: '',
      type: 'non',
    });
    this.searchResult = [];
    this.loadTableData();
  }

  protected readonly max = max;
}
